import React from "react";
import { Map, Route, Truck } from "lucide-react";
import "./PublicFeatureBanner.css";

const features = [
  {
    description: "Affectez vos commandes selon les capacités et contraintes de votre flotte.",
    icon: Truck,
    title: "Affectation intelligente",
  },
  {
    description: "Construisez des tournées adaptées à vos opérations.",
    icon: Route,
    title: "Optimisation des routes",
  },
  {
    description: "Consultez vos coûts, vos résultats et vos marges.",
    icon: Map,
    title: "Analyse & marges",
  },
];

export default function PublicFeatureBanner({ id, compact = false }) {
  return (
    <section id={id} className={`public-feature-banner${compact ? " public-feature-banner--compact" : ""}`} aria-label="Fonctionnalités">
      <div className="public-feature-banner__grid">
        {features.map(({ description, icon: Icon, title }) => (
          <article key={title} className="public-feature-banner__item">
            <span className="public-feature-banner__icon">
              <Icon size={30} aria-hidden="true" />
            </span>
            <div>
              <h2>{title}</h2>
              <p>{description}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
